import { mapDTO } from '@twistezo/ts-dto-mapper'

import { TransferListItem } from 'components/Form/TransferList'
import { alertsFromDTO } from 'features/alerts/api/mappers/alertFromDTO'
import { adUnitRefresherFromDTO } from 'features/inventory/ad-unit/api/mappers/adUnitRefresher'
import { adUnitViewabilityToolsFromDTO } from 'features/inventory/ad-unit/api/mappers/adUnitViewabilityTools'
import { AdUnitAlert } from 'features/inventory/ad-unit/types/adUnitAlert'
import { AdUnitDTO } from 'features/inventory/api/types/adUnitDTO'
import { PageDTO } from 'features/inventory/api/types/pageDTO'
import { mediaTypesFromDTO } from 'features/inventory/mappers/adUnit/mediaTypes'
import { domainFromDTO } from 'features/inventory/mappers/domain'
import { pageForTransferListFromDTO } from '../../../useGetPagesForAdUnitTransferList/api/mapper'
import { AdUnitForForm } from '../../types'

export const adUnitForFormFromDTO = (from: AdUnitDTO): AdUnitForForm =>
  mapDTO<AdUnitDTO, AdUnitForForm>({ from }).transform((adUnitDTO: AdUnitDTO): AdUnitForForm => {
    const {
      adUnitAmazonEnabled,
      adUnitId,
      adUnitRefresher,
      adUnitViewabilityTool,
      divId,
      domain,
      fieldAlerts,
      mediaTypes,
      name,
      pages,
    } = adUnitDTO

    return {
      ...adUnitDTO,
      adUnitAmazonEnabled: adUnitAmazonEnabled ?? undefined,
      adUnitRefresher: adUnitRefresher ? adUnitRefresherFromDTO(adUnitRefresher) : undefined,
      adUnitViewabilityTool: adUnitViewabilityToolsFromDTO(adUnitViewabilityTool),
      alerts: alertsFromDTO<AdUnitAlert>(fieldAlerts),
      divId: divId || undefined,
      domain: domainFromDTO(domain),
      mediaTypes: mediaTypesFromDTO(mediaTypes),
      name: name || undefined,
      pages: pages
        .map((page: PageDTO): TransferListItem => pageForTransferListFromDTO(page))
        .toSorted((a: TransferListItem, b: TransferListItem): number =>
          a.value.toLowerCase().localeCompare(b.value.toLowerCase()),
        ),
      rawId: adUnitId || undefined,
      ybAdUnitEnabled: adUnitDTO.ybAdUnitEnabled ?? undefined,
    }
  })
